<div class="oam-detail">
  <div class="oam-title">
    <app-text class="title text-bg33 pt-4">{{oamData?.name}}</app-text>
  </div>
  <app-brush [brushColor]="'bg-s30'" [color]="'text-bg33'" [padding]="17">{{ locale?.oamViewData.about }}</app-brush>
  <div class="oam-description">
    <app-text class="body-xl-light text-c100">{{oamData?.description}}</app-text>
  </div>
</div>
